(function () {
	'use strict';

	/* This asset is <script src>-included from inside each section that needs it
	   (m1o2-landing-product-box / m1o2-landing-expo / m1o2-landing-sport-tiles),
	   the same way sections/m1o2-testimonials.liquid loads its own JS - landing
	   pages routinely stack 2-3 of those sections, so guard against re-running
	   init() (and attaching duplicate listeners) if the tag appears more than once. */
	if (window.__m1o2LandingMainLoaded) return;
	window.__m1o2LandingMainLoaded = true;

	/* Product card variant-pill switcher + AJAX add-to-cart (m1o2-landing-product-box, m1o2-lp-products). */
	function initProductCards() {
		var cards = document.querySelectorAll('[data-m1o2-product-card]');
		cards.forEach(function (card) {
			var pills = card.querySelectorAll('[data-m1o2-variant-pill]');
			var variantInput = card.querySelector('[data-m1o2-variant-input]');
			var cartBtnText = card.querySelector('[data-m1o2-cart-btn-text]');
			var cartBtn = cartBtnText ? cartBtnText.closest('button') : null;
			var descEl = card.querySelector('[data-m1o2-card-desc]');
			var imgEl = card.querySelector('[data-m1o2-card-img]');

			pills.forEach(function (pill) {
				pill.addEventListener('click', function () {
					pills.forEach(function (p) {
						p.classList.remove('is-active');
						p.setAttribute('aria-pressed', 'false');
					});
					pill.classList.add('is-active');
					pill.setAttribute('aria-pressed', 'true');
					if (variantInput) variantInput.value = pill.getAttribute('data-variant-id');
					/* The button follows the chosen size's stock: SOLD OUT + disabled for a sold-out
					   size, re-enabled for an available one. It used to relabel to ADD TO CART on
					   every pill without touching `disabled`, so a card that loaded sold out showed
					   ADD TO CART but ignored clicks. A pill with no availability data counts as
					   available, as before. */
					var available = pill.getAttribute('data-variant-available') !== 'false';
					if (cartBtnText) {
						cartBtnText.textContent = available ? 'ADD TO CART - ' + pill.getAttribute('data-variant-price') : 'SOLD OUT';
					}
					if (cartBtn) cartBtn.disabled = !available;
					/* Per-size copy + image (snippets/m1o2-variant-card-data.liquid). A size with
					   no image of its own keeps the current one. */
					var desc = pill.getAttribute('data-variant-desc');
					if (descEl && desc) descEl.textContent = desc;
					var img = pill.getAttribute('data-variant-image');
					if (imgEl && img) {
						imgEl.removeAttribute('srcset');
						imgEl.src = img;
					}
				});
			});

			var form = card.querySelector('[data-m1o2-ajax-cart-form]');
			if (!form) return;
			form.addEventListener('submit', function (evt) {
				evt.preventDefault();
				var button = form.querySelector('[data-m1o2-cart-btn]') || form.querySelector('.m1o2-landing-product-box__card-cart');
				var textEl = form.querySelector('[data-m1o2-cart-btn-text]');
				if (!button || !textEl || button.disabled) return;
				var originalText = textEl.textContent;
				button.disabled = true;
				textEl.textContent = 'Adding…';

				var id = variantInput ? variantInput.value : null;
				if (!id) {
					button.disabled = false;
					textEl.textContent = originalText;
					return;
				}

				fetch('/cart/add.js', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
					body: JSON.stringify({ id: id, quantity: 1 })
				})
					.then(function (res) {
						if (!res.ok) return res.json().then(function (data) { throw data; });
						return res.json();
					})
					.then(function (item) {
						button.classList.add('is-added');
						textEl.textContent = 'Added ✓';
						document.dispatchEvent(new CustomEvent('m1o2:cart:updated', { bubbles: true, detail: { item: item } }));
						window.setTimeout(function () {
							button.classList.remove('is-added');
							button.disabled = false;
							textEl.textContent = originalText;
						}, 1800);
					})
					.catch(function () {
						textEl.textContent = "Couldn't add - try again";
						window.setTimeout(function () {
							button.disabled = false;
							textEl.textContent = originalText;
						}, 2200);
					});
			});
		});
	}

	/* Sport tiles: tap-to-reveal on touch/keyboard, in addition to the CSS :hover
	   affordance, so the highlighted-copy state is reachable without a mouse. */
	function initSportTiles() {
		var tiles = document.querySelectorAll('[data-m1o2-sport-tile]');
		tiles.forEach(function (tile) {
			tile.addEventListener('click', function (evt) {
				if (tile.getAttribute('href') === '#') evt.preventDefault();
				tiles.forEach(function (t) {
					if (t !== tile) t.classList.remove('is-revealed');
				});
				tile.classList.toggle('is-revealed');
			});
		});
		document.addEventListener('click', function (evt) {
			if (!(evt.target instanceof Element) || !evt.target.closest('[data-m1o2-sport-tile]')) {
				tiles.forEach(function (t) { t.classList.remove('is-revealed'); });
			}
		});
	}

	function init() {
		initProductCards();
		initSportTiles();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
